"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7484],{

/***/ 13464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98494);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15746);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var dataSource = function dataSource() {
  return {
    wrapper: {
      className: 'home-page-wrapper abovefooter-wrapper'
    },
    page: {
      className: 'home-page abovefooter'
    },
    OverPack: {
      playScale: 0.3
    },
    logo: {
      className: 'abovefooter-logo',
      children: '/static/images/logo.svg'
    },
    titleWrapper: {
      className: 'abovefooter-title-wrapper',
      children: [{
        name: 'title',
        className: 'abovefooter-title-h1',
        children: 'Your One Stop Solution to Financial Queries'
      }]
    },
    secondtitleWrapper: {
      className: 'abovefooter-title2-wrapper',
      children: [{
        name: 'title',
        className: 'abovefooter-title2-h1',
        children: 'Trusted By Millions of Readers'
      }]
    },
    thirdtitleWrapper: {
      className: 'abovefooter-title3-wrapper',
      children: [{
        name: 'title',
        className: 'abovefooter-title3-h1',
        children: 'Explore Our FAQ Section'
      }]
    }
  };
};

function AboveFooter(props) {
  var dataSourceWithBrokers = dataSource();
  var titleWrapper = dataSourceWithBrokers.titleWrapper,
      wrapper = dataSourceWithBrokers.wrapper,
      page = dataSourceWithBrokers.page,
      logo = dataSourceWithBrokers.logo,
      secondtitleWrapper = dataSourceWithBrokers.secondtitleWrapper,
      thirdtitleWrapper = dataSourceWithBrokers.thirdtitleWrapper;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, props), wrapper), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", _objectSpread(_objectSpread({}, page), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({}, titleWrapper), {}, {
        children: titleWrapper.children.map(shared_util__WEBPACK_IMPORTED_MODULE_3__/* .getChildrenToRender */ .TU)
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({}, logo), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
          width: "150px",
          src: logo.children,
          alt: "img"
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({}, secondtitleWrapper), {}, {
        children: secondtitleWrapper.children.map(shared_util__WEBPACK_IMPORTED_MODULE_3__/* .getChildrenToRender */ .TU)
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "abovefooter-ratings",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          disabled: true,
          xs: 24,
          value: 5
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({}, thirdtitleWrapper), {}, {
        children: thirdtitleWrapper.children.map(shared_util__WEBPACK_IMPORTED_MODULE_3__/* .getChildrenToRender */ .TU)
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        type: "flex",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 8,
          lg: 6,
          style: {
            textAlign: 'center',
            padding: '5px'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/faqs/stock-market",
            children: "Stock Market FAQ"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 8,
          lg: 6,
          style: {
            textAlign: 'center',
            padding: '5px'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/faqs/investment",
            children: "Investment FAQ"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 8,
          lg: 6,
          style: {
            textAlign: 'center',
            padding: '5px'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/faqs/finance",
            children: "Finance FAQ"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 8,
          lg: 6,
          style: {
            textAlign: 'center',
            padding: '5px'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: "/faqs/investment",
            children: "Broker FAQ"
          })
        })]
      })]
    }))
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (AboveFooter);

/***/ }),

/***/ 29078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Banner3; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/auto-complete/index.js
var auto_complete = __webpack_require__(49288);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(42561);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./graphql/generated/types.tsx
var types = __webpack_require__(13492);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/article/QueryAutoComplete.js








function QueryAutoComplete() {
  var _router$query;

  var _useLazyQuery = (0,useLazyQuery/* useLazyQuery */.t)(types/* ArticleSearchByKeywordDocument */.md),
      _useLazyQuery2 = (0,slicedToArray/* default */.Z)(_useLazyQuery, 2),
      getData = _useLazyQuery2[0],
      _useLazyQuery2$ = _useLazyQuery2[1],
      data = _useLazyQuery2$.data,
      loading = _useLazyQuery2$.loading;

  var _useState = (0,react.useState)(false),
      openDropDown = _useState[0],
      setOpenDropDown = _useState[1];

  var router = (0,next_router.useRouter)();
  var countrySlug = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.country_slug;
  var options = [];

  if (loading) {
    options = [{
      label: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "loading..."
      })
    }];
  }

  if (data) {
    options = data.articleSearchByKeyword.map(function (item) {
      return {
        label: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: 'flex'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/article/[slug]",
              as: "/article/".concat(item.slug),
              children: item.title
            })
          })
        })
      };
    });
  }

  var searchResult = function searchResult(value) {
    if (value.length > 2) {
      getData({
        variables: {
          where: countrySlug ? {
            keyword: value,
            country: countrySlug
          } : {
            keyword: value
          },
          limit: 5
        }
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    style: {
      justifyContent: 'center',
      marginTop: '32px'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(auto_complete/* default */.Z, {
      style: {
        width: '500px'
      },
      onSearch: searchResult,
      options: options,
      open: openDropDown,
      onFocus: function onFocus() {
        return setOpenDropDown(true);
      },
      onBlur: function onBlur() {
        return setOpenDropDown(false);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default.Search */.Z.Search, {
        size: "large",
        placeholder: "e.g What is cover order?"
      })
    })
  });
}
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
// EXTERNAL MODULE: ./node_modules/rc-texty/es/index.js + 2 modules
var es = __webpack_require__(16643);
// EXTERNAL MODULE: ./node_modules/rc-texty/assets/index.css
var assets = __webpack_require__(18043);
;// CONCATENATED MODULE: ./components/home/Banner3.tsx



var _excluded = ["name", "texty"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Banner = function Banner(props) {
  var currentProps = (0,esm_extends/* default */.Z)({}, props);

  var dataSource = currentProps.dataSource;
  delete currentProps.dataSource;
  delete currentProps.isMobile;
  var children = dataSource.textWrapper.children.map(function (item) {
    var name = item.name,
        texty = item.texty,
        $item = (0,objectWithoutProperties/* default */.Z)(item, _excluded);

    if (name.match('button')) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, _objectSpread(_objectSpread({
        type: "primary"
      }, $item), {}, {
        children: item.children
      }), name);
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, $item), {}, {
      children: texty ? /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
        type: "mask-bottom",
        children: item.children
      }) : item.children
    }), name);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, currentProps), dataSource.wrapper), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _objectSpread(_objectSpread({}, dataSource.textWrapper), {}, {
      children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(QueryAutoComplete, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          color: 'white',
          height: '32px',
          margin: '4px'
        },
        children: "OR"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
        href: "/create-faq",
        source: "ask-query",
        children: "ASK YOUR QUERY"
      })]
    }))
  }));
};

/* harmony default export */ var Banner3 = (Banner);

/***/ }),

/***/ 6228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ant_design_compatible__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31105);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87547);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37911);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



 // import dateformat from 'dateformat'







var dataSource = function dataSource() {
  return {
    wrapper: {
      className: 'home-page-wrapper commentSection-wrapper'
    },
    page: {
      className: 'home-page commentSection'
    },
    OverPack: {
      playScale: 0.3
    },
    titleWrapper: {
      className: 'commentSection-title-wrapper',
      children: [{
        name: 'title',
        className: 'commentSection-title-h1',
        children: 'Top Reader Comments'
      }]
    }
  };
};

function CommentSection(props) {
  var _comments$, _comments$2, _comments$3, _comments$4, _comments$5, _comments$6;

  var comments = props.comments;
  var dataSourceWithBrokers = dataSource();
  var titleWrapper = dataSourceWithBrokers.titleWrapper;

  var truncatedString = function truncatedString(str) {
    return str === null || str === void 0 ? void 0 : str.split(' ', 20).join(' ');
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({}, dataSourceWithBrokers.wrapper), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", _objectSpread(_objectSpread({}, dataSourceWithBrokers.page), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({}, dataSourceWithBrokers.titleWrapper), {}, {
        children: titleWrapper.children.map(shared_util__WEBPACK_IMPORTED_MODULE_3__/* .getChildrenToRender */ .TU)
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        gutter: [150, 0],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_compatible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            content: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              id: comments[0].createdAt,
              children: [truncatedString(comments[0].content), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/article/".concat(comments[0].articleSlug),
                children: "Check Detailed Reviews"
              })]
            }),
            author: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h3", {
              children: comments[0].author && comments[0].author.name
            }),
            avatar: comments[0].author.avatar ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              src: comments[0].author.avatar
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              size: 55,
              icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }) // datetime={dateformat(
            //   new Date(JSON.parse(comments[0].createdAt)),
            //   'dddd, mmmm dS, yyyy, h:MM TT'
            // )}

          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_compatible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            content: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              id: comments[1].createdAt,
              children: [truncatedString(comments[1].content), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/article/".concat(comments[1].articleSlug),
                children: "Check Detailed Reviews"
              })]
            }),
            author: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h3", {
              children: comments[1].author && comments[1].author.name
            }),
            avatar: comments[1].author.avatar ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              src: comments[1].author.avatar
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              size: 55,
              icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }) // datetime={dateformat(
            //   new Date(JSON.parse(comments[1].createdAt)),
            //   'dddd, mmmm dS, yyyy, h:MM TT'
            // )}

          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_compatible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            content: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              id: comments[2].createdAt,
              children: [truncatedString(comments[2].content), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/article/".concat(comments[2].articleSlug),
                children: "Check Detailed Reviews"
              })]
            }),
            author: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h3", {
              children: comments[2].author && comments[2].author.name
            }),
            avatar: comments[2].author.avatar ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              src: comments[2].author.avatar
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              size: 55,
              icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }) // datetime={dateformat(
            //   new Date(JSON.parse(comments[2].createdAt)),
            //   'dddd, mmmm dS, yyyy, h:MM TT'
            // )}

          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_compatible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            content: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              id: (_comments$ = comments[3]) === null || _comments$ === void 0 ? void 0 : _comments$.createdAt,
              children: [truncatedString((_comments$2 = comments[3]) === null || _comments$2 === void 0 ? void 0 : _comments$2.content), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/article/".concat((_comments$3 = comments[3]) === null || _comments$3 === void 0 ? void 0 : _comments$3.articleSlug),
                children: "Check Detailed Reviews"
              })]
            }),
            author: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h3", {
              children: ((_comments$4 = comments[3]) === null || _comments$4 === void 0 ? void 0 : _comments$4.author) && ((_comments$5 = comments[3]) === null || _comments$5 === void 0 ? void 0 : _comments$5.author.name)
            }),
            avatar: (_comments$6 = comments[3]) !== null && _comments$6 !== void 0 && _comments$6.author.avatar ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              src: comments[3].author.avatar
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .C, {
              size: 55,
              icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }) // datetime={dateformat(
            //   new Date(JSON.parse(comments[3].createdAt)),
            //   'dddd, mmmm dS, yyyy, h:MM TT'
            // )}

          })
        })]
      })]
    }))
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CommentSection);

/***/ }),

/***/ 56265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15746);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87160);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var dataSource = function dataSource() {
  return {
    wrapper: {
      className: 'home-page-wrapper pquestions-wrapper'
    },
    page: {
      className: 'home-page pquestions'
    },
    OverPack: {
      playScale: 0.3
    },
    titleWrapper: {
      className: 'pquestions-title-wrapper',
      children: [{
        name: 'title',
        className: 'pquestions-title-h1',
        children: 'Popular Frequently Asked Questions or FAQs'
      }, {
        name: 'content',
        className: 'pquestions-title-content',
        children: 'What People Ask'
      }]
    }
  };
};

function PopularQuestions(props) {
  var articles = props.articles;
  var dataSourceWithBrokers = dataSource();
  var titleWrapper = dataSourceWithBrokers.titleWrapper,
      wrapper = dataSourceWithBrokers.wrapper,
      page = dataSourceWithBrokers.page;

  var _ref = articles || {},
      investment_faqs = _ref.investment_faqs,
      finance_faqs = _ref.finance_faqs,
      stock_market_faqs = _ref.stock_market_faqs,
      ipo_basics_faqs = _ref.ipo_basics_faqs,
      option_trading_faqs = _ref.option_trading_faqs,
      mutual_funds_faqs = _ref.mutual_funds_faqs,
      stock_trading_faqs = _ref.stock_trading_faqs,
      financial_terms_faqs = _ref.financial_terms_faqs,
      trading_software_faqs = _ref.trading_software_faqs,
      stock_broker_faqs = _ref.stock_broker_faqs,
      banking_faqs = _ref.banking_faqs,
      tfsa_faqs = _ref.tfsa_faqs,
      rrsp_faqs = _ref.rrsp_faqs,
      cpp_faqs = _ref.cpp_faqs,
      resp_faqs = _ref.resp_faqs,
      credit_card_faqs = _ref.credit_card_faqs,
      new_immigrant_faqs = _ref.new_immigrant_faqs,
      mortgage_faqs = _ref.mortgage_faqs,
      crypto_currency_faqs = _ref.crypto_currency_faqs,
      real_estate_faqs = _ref.real_estate_faqs;

  var investmentFaqs = [];
  var financeFaqs = [];
  var stockMarketFaqs = [];
  var ipoBasicsFaqs = [];
  var financialTermsFaqs = [];
  var optionTradingFaqs = [];
  var stockBrokerFaqs = [];
  var mutualFundsFaqs = [];
  var stockTradingFaqs = [];
  var tradingSoftwareFaqs = [];
  var bankingFaqs = [];
  var tfsaFaqs = [];
  var cppFaqs = [];
  var rrspFaqs = [];
  var respFaqs = [];
  var creditCardFaqs = [];
  var newImmigrantFaqs = [];
  var mortgageFaqs = [];
  var realEstateFaqs = [];
  var cryptocurrencyFaqs = [];

  var urlObj = function urlObj(article) {
    return {
      href: '/article/[slug]',
      as: "/article/".concat(article.slug),
      linkText: " ".concat(article.title)
    };
  };

  investment_faqs === null || investment_faqs === void 0 ? void 0 : investment_faqs.forEach(function (article) {
    investmentFaqs.push(urlObj(article));
  });
  finance_faqs === null || finance_faqs === void 0 ? void 0 : finance_faqs.forEach(function (article) {
    financeFaqs.push(urlObj(article));
  });
  stock_market_faqs === null || stock_market_faqs === void 0 ? void 0 : stock_market_faqs.forEach(function (article) {
    stockMarketFaqs.push(urlObj(article));
  });
  ipo_basics_faqs === null || ipo_basics_faqs === void 0 ? void 0 : ipo_basics_faqs.forEach(function (article) {
    ipoBasicsFaqs.push(urlObj(article));
  });
  financial_terms_faqs === null || financial_terms_faqs === void 0 ? void 0 : financial_terms_faqs.forEach(function (article) {
    financialTermsFaqs.push(urlObj(article));
  });
  option_trading_faqs === null || option_trading_faqs === void 0 ? void 0 : option_trading_faqs.forEach(function (article) {
    optionTradingFaqs.push(urlObj(article));
  });
  stock_broker_faqs === null || stock_broker_faqs === void 0 ? void 0 : stock_broker_faqs.forEach(function (article) {
    stockBrokerFaqs.push(urlObj(article));
  });
  mutual_funds_faqs === null || mutual_funds_faqs === void 0 ? void 0 : mutual_funds_faqs.forEach(function (article) {
    mutualFundsFaqs.push(urlObj(article));
  });
  stock_trading_faqs === null || stock_trading_faqs === void 0 ? void 0 : stock_trading_faqs.forEach(function (article) {
    stockTradingFaqs.push(urlObj(article));
  });
  trading_software_faqs === null || trading_software_faqs === void 0 ? void 0 : trading_software_faqs.forEach(function (article) {
    tradingSoftwareFaqs.push(urlObj(article));
  });
  banking_faqs === null || banking_faqs === void 0 ? void 0 : banking_faqs.forEach(function (article) {
    bankingFaqs.push(urlObj(article));
  });
  tfsa_faqs === null || tfsa_faqs === void 0 ? void 0 : tfsa_faqs.forEach(function (article) {
    tfsaFaqs.push(urlObj(article));
  });
  cpp_faqs === null || cpp_faqs === void 0 ? void 0 : cpp_faqs.forEach(function (article) {
    cppFaqs.push(urlObj(article));
  });
  rrsp_faqs === null || rrsp_faqs === void 0 ? void 0 : rrsp_faqs.forEach(function (article) {
    rrspFaqs.push(urlObj(article));
  });
  resp_faqs === null || resp_faqs === void 0 ? void 0 : resp_faqs.forEach(function (article) {
    respFaqs.push(urlObj(article));
  });
  credit_card_faqs === null || credit_card_faqs === void 0 ? void 0 : credit_card_faqs.forEach(function (article) {
    creditCardFaqs.push(urlObj(article));
  });
  new_immigrant_faqs === null || new_immigrant_faqs === void 0 ? void 0 : new_immigrant_faqs.forEach(function (article) {
    newImmigrantFaqs.push(urlObj(article));
  });
  mortgage_faqs === null || mortgage_faqs === void 0 ? void 0 : mortgage_faqs.forEach(function (article) {
    mortgageFaqs.push(urlObj(article));
  });
  real_estate_faqs === null || real_estate_faqs === void 0 ? void 0 : real_estate_faqs.forEach(function (article) {
    realEstateFaqs.push(urlObj(article));
  });
  crypto_currency_faqs === null || crypto_currency_faqs === void 0 ? void 0 : crypto_currency_faqs.forEach(function (article) {
    cryptocurrencyFaqs.push(urlObj(article));
  });
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var country = router.query.country_slug;

  if (country === 'ca') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, props), wrapper), {}, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", _objectSpread(_objectSpread({}, page), {}, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", _objectSpread(_objectSpread({}, titleWrapper), {}, {
          children: titleWrapper.children.map(shared_util__WEBPACK_IMPORTED_MODULE_4__/* .getChildrenToRender */ .TU)
        })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          gutter: [150, 56],
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Stock Market",
              linkList: stockMarketFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Banking",
              linkList: bankingFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Finance",
              linkList: financeFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Investment",
              linkList: investmentFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "TFSA",
              linkList: tfsaFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "CPP",
              linkList: cppFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "RRSP",
              linkList: rrspFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "RESP",
              linkList: respFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Credit Cards",
              linkList: creditCardFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "New Immigrants",
              linkList: newImmigrantFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Mortgage",
              linkList: mortgageFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Real Estate",
              linkList: realEstateFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Trading Software",
              linkList: tradingSoftwareFaqs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              title: "Cryptocurrency",
              linkList: cryptocurrencyFaqs
            })
          })]
        })]
      }))
    }));
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, props), wrapper), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", _objectSpread(_objectSpread({}, page), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", _objectSpread(_objectSpread({}, titleWrapper), {}, {
        children: titleWrapper.children.map(shared_util__WEBPACK_IMPORTED_MODULE_4__/* .getChildrenToRender */ .TU)
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        gutter: [150, 56],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Investment Faqs",
            linkList: investmentFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Finance Faqs",
            linkList: financeFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Stock Market Faqs",
            linkList: stockMarketFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "IPO Basics Faqs",
            linkList: ipoBasicsFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Financial Terms Faqs",
            linkList: financialTermsFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Option Trading Faqs",
            linkList: optionTradingFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Stock Brokers Faqs",
            linkList: stockBrokerFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Mutual Funds Faqs",
            linkList: mutualFundsFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Stock Trading Faqs",
            linkList: stockTradingFaqs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          xs: 24,
          lg: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            title: "Trading Software Faqs",
            linkList: tradingSoftwareFaqs
          })
        })]
      })]
    }))
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (PopularQuestions);

/***/ }),

/***/ 49091:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var Banner30DataSource = {
  wrapper: {
    className: 'banner3'
  },
  textWrapper: {
    className: 'banner3-text-wrapper',
    children: [{
      name: 'nameEn',
      className: 'banner3-name-en',
      children: 'Keep Your Finances on the Right Track'
    }, {
      name: 'slogan',
      className: 'banner3-slogan',
      children: 'Financial Knowledge, Tools & Products',
      texty: true
    }, {
      name: 'name',
      className: 'banner3-name',
      children: 'Ask Your Query & Get Answers from Real Experts'
    }]
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner30DataSource);

/***/ }),

/***/ 87160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87547);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88641);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3679);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var titleFormat = function titleFormat(linkTitle, icon) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [icon, " ".concat(linkTitle)]
  });
};

function QuickLinks(props) {
  var icon = props.icon,
      title = props.title,
      linkList = props.linkList,
      country = props.country;
  if (linkList < 1 || linkList === 'undefined') return null;
  return linkList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [country === 'India' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      style: {
        paddingBottom: '32px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        style: {
          minWidth: '250px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
          target: "_blank",
          href: "https://bit.ly/2YUNebF",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            width: 252,
            height: 302,
            alt: "",
            "data-src": "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
            src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z // eslint-disable-next-line prettier/prettier
    , {
      title: titleFormat(title, icon),
      size: "small",
      bordered: false,
      style: {
        // float: 'right',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '2px',
        minWidth: '100%',
        marginBottom: '16px'
      },
      headStyle: {
        background: '#E6F7FF',
        padding: '5px 0px 0px 25px'
      },
      bodyStyle: {
        padding: '15px 20px 0px 25px',
        minWidth: '272px'
      },
      children: linkList.map(function (qlink, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          style: {
            marginBottom: '1em'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: qlink.href,
            as: qlink.as,
            children: qlink.linkText
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            style: {
              fontSize: '10px'
            },
            children: qlink.textDescription !== 'null' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
              children: qlink.textDescription
            }) : null
          })]
        }, i);
      })
    })]
  }) : null;
}
QuickLinks.defaultProps = {
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
};

/***/ })

}]);